// Hiển thị thông báo NGOÀI trang (OS notification, kiểu Zalo/Windows) - không phải toast trong app.
//
// Ưu tiên service worker (registration.showNotification): đây là cách Chrome hiển thị noti
// dạng persistent, còn nằm lại trong Trung tâm thông báo của Windows và bấm vào được.
// `new Notification()` chỉ là phương án dự phòng: một số nền tảng (Chrome Android) ném lỗi,
// và trên desktop noti kiểu này tự biến mất, không lưu lại.
// `data` nên là payload.data của FCM (chứa type/objectId/notiId) để service worker
// dựng được link trang chi tiết khi người dùng bấm vào thông báo.
export const showOsNotification = async ({ title, body, icon, tag, data }) => {
  if (typeof Notification === "undefined") return "unsupported";
  if (Notification.permission !== "granted") return Notification.permission; // "default" | "denied"

  const options = {
    body: body || "",
    icon: icon || "/favicon.ico",
    badge: "/favicon.ico",
    tag, // cùng tag -> thay thế noti cũ thay vì hiện chồng
    requireInteraction: false,
    data: data || {},
  };

  try {
    if ("serviceWorker" in navigator) {
      // KHÔNG dùng navigator.serviceWorker.ready: nếu chưa có SW nào đăng ký thì
      // promise đó treo vĩnh viễn. Lấy registration hiện có, chưa có thì tự đăng ký.
      let reg = await navigator.serviceWorker.getRegistration();
      if (!reg) {
        reg = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
      }
      if (reg) {
        await reg.showNotification(title || "Thông báo", options);
        return "shown-sw";
      }
    }
  } catch (e) {
    // rơi xuống fallback bên dưới
  }

  try {
    const n = new Notification(title || "Thông báo", options);
    n.onclick = () => {
      window.focus();
      n.close();
    };
    return "shown-window";
  } catch (e) {
    return "failed";
  }
};
